import { render, staticRenderFns } from "./Overseas.vue?vue&type=template&id=62ed9767"
import script from "./Overseas.vue?vue&type=script&lang=js"
export * from "./Overseas.vue?vue&type=script&lang=js"
import style0 from "./Overseas.vue?vue&type=style&index=0&id=62ed9767&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports